import React from 'react';
import { FontWeight, Size } from '../../../styles/theme.mjs';
import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import FacebookIcon from '../../Basic/Icons/SocialMediaIcons/FacebookIcon.mjs';
import { useTheme } from 'styled-components';
import TwitterIcon from '../../Basic/Icons/SocialMediaIcons/TwitterIcon.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import StoryInfo from '../StoryInfo/StoryInfo.mjs';
import { StyledStoryTitleContainer } from './StoryTitle.styles.mjs';

var SharingMethod;
(function (SharingMethod) {
    SharingMethod["FACEBOOK"] = "facebook";
    SharingMethod["TWITTER"] = "twitter";
    SharingMethod["LINK"] = "link";
})(SharingMethod || (SharingMethod = {}));
const StoryTitle = ({ title, subTitle, authors, date, updatedAt, onShare }) => {
    const theme = useTheme();
    return (React.createElement(StyledStoryTitleContainer, null,
        React.createElement(FlexContainer, { direction: "column", gap: "1rem" },
            React.createElement(Heading, { tag: "h2" }, title),
            React.createElement(DesktopOnly, { breakpoint: theme.breakpoints.sm },
                React.createElement(Heading, { tag: "h3", fontWeight: FontWeight.Regular }, subTitle)),
            React.createElement(StoryInfo, { authors: authors, date: date, updatedAt: updatedAt }),
            React.createElement(FlexContainer, { gap: "1rem" },
                React.createElement(TextComponent, { color: theme.colors.darkGray, tag: "p", size: Size.Tiny }, "Share:"),
                React.createElement(IconButtonComponent, { className: "share-btn share-btn-facebook", iconType: "custom", onClick: () => onShare(SharingMethod.FACEBOOK) },
                    React.createElement(FacebookIcon, null)),
                React.createElement(IconButtonComponent, { className: "share-btn share-btn-twitter", iconType: "custom", onClick: () => onShare(SharingMethod.TWITTER) },
                    React.createElement(TwitterIcon, null)),
                React.createElement(IconButtonComponent, { className: "share-btn share-btn-link", iconType: "link", onClick: () => onShare(SharingMethod.LINK) })))));
};

export { SharingMethod, StoryTitle as default };
//# sourceMappingURL=StoryTitle.mjs.map
